import Api from "@/services/api.js";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  props: ["cnpj_value", "id_empresa", "intIndexMensagem", "preencheCnpj"],
  components: {
    BotaoPadrao,
    Header,
    LoadingPadraoContainer
  },
  data() {
    return {
      desativado: false,
      icone_sync: false,
      captcha_exibir: false,
      icone_spyn: true,
      captcha_img: false,
      captcha_value: "",
      blTimeout: false,
      blLoading: false,
      blLoadingButton: false,
      idConn: false,
      blErro: false,
      strErro: "",
      arMensagem: [
        "Tempo excedido de resposta do servidor da Receita Federal. <br> Se a imagem não aparecer, tente novamente mais tarde ou selecione um CNAE manualmente.",
        "Tempo excedido de resposta do servidor da Receita Federal. <br> Se a imagem não aparecer, tente novamente mais tarde ou adicione as CNAEs manualmente."
      ]
    };
  },

  methods: {
    verificaCNPJ(id, origem, cenario, blMantemErro = false) {

      this.cenario = cenario;

      if(cenario){
        this.id = id;
        this.origem = origem;
        this.captcha_value = "";
        this.$refs.verificacaoCnae.show();

        this.captcha_exibir = false;
        this.captcha_img = false;
        this.blTimeout = false;
        this.blLoading = true;
        this.strErro = '';

        if (!blMantemErro) this.blErro = false;

        this.captchaId = this.initializeHCaptcha();

        if (this.desativado) return;
        this.blLoading = false;
      }else{
        this.captcha_value = "";
        this.$refs.verificacaoCnae.show();

        this.captcha_exibir = false;
        this.captcha_img = false;
        this.blTimeout = false;
        this.blLoading = true;

        if (!blMantemErro) this.blErro = false;

        this.captchaId = this.initializeHCaptcha();

        if (this.desativado) return;
        this.blLoading = false;
      }
    },
    initializeHCaptcha() {
      const siteKey = "af4fc5a3-1ac5-4e6d-819d-324d412a5e9d";
      if (siteKey) {
        const captchaId = hcaptcha.render('h-captcha-div', {
          sitekey: siteKey,
          callback: this.onCaptchaCompleted
        });

        return captchaId;
      }
    },
    onCaptchaCompleted(response) {
      const cnpjValue = this.cnpj_value;
      this.blLoading = true;

      new Api().post("Cnpj/checkCnpj", {
        cnpj: cnpjValue,
        hcaptcharesponse: response
      })
      .then(response => {
        if (response.dados.cnpj) {
          if (response.dados.situacao_cadastral == "BAIXADA") {
            this.blErro = true;
            this.strErro = "Verificar situação cadastral da empresa.";
          } else {

            if(this.cenario){
              this.cnaeValue = response.dados.cnaes[0].id_cnae;
              this.preencheCnpj(this.id, this.origem, response.dados.cnpj, this.cnaeValue);
              this.closeModal();
            }else{
              this.$parent.blAtualizarReceita = false;
              this.$parent.setCnaeCnpj(response.dados);
              this.closeModal();
            }
          }
        } else {
          this.blErro = true;

          if (response.mensagem instanceof Object) {
            Object.keys(response.mensagem).map(key => {
              this.strErro += response.mensagem[key][0] + "<br>";
            });
          } else {
            this.strErro = response.mensagem;

            if (response.mensagem == "Imagem digitada incorretamente")
              this.verificaCNPJ(this.id, this.origem, true);
          }
        }

        this.blLoading = false;
      });
    },
    resetHCaptcha(captchaId) {
      hcaptcha.reset(captchaId);
    },
    closeModal: function() {
      // if (this.blLoadingButton) {
      //   return;
      // }

      this.resetHCaptcha(this.captchaId);
      this.$refs.verificacaoCnae.hide();
    }
  }

  // methods: {
  //   verificaCNPJ(blMantemErro = false) {
  //     this.captcha_value = "";
  //     this.$refs.verificacaoCnae.show();

  //     let that = this;
  //     //this.cnpj_value = this.cnpj_value = $('#pesquisaCNPJCenario' + this.id).val();
  //     this.captcha_exibir = false;
  //     this.captcha_img = false;
  //     this.blTimeout = false;
  //     this.blLoading = true;

  //     if (!blMantemErro) this.blErro = false;

  //     var timer = setTimeout(function() {
  //       that.blTimeout = true;
  //       that.blLoading = false;
  //     }, 100000);

  //     new Api().get("Cnpj/getCaptcha").then(response => {
  //       clearTimeout(timer);

  //       var dados = response.dados;
  //       this.captcha_img = dados.imagem;
  //       this.idConn = dados.idConn;
  //       this.captcha_exibir = true;
  //       this.blLoading = false;

  //       if (dados.imagem != null) {
  //         this.blTimeout = false;
  //       }

  //       if (typeof dados.imagem === "undefined" || dados.imagem == "") {
  //         this.captcha_exibir = false;
  //       }

  //       //this.$refs.refCaptcha.$el.focus();
  //       setTimeout(() => {
  //         this.$refs.refCaptcha.focus();
  //       }, 250);
  //     });
  //   },
  //   capturaCNAE() {
  //     var that = this;
  //     this.strErro = "";
  //     this.blErro = false;
  //     this.blLoadingButton = true;

  //     new Api()
  //       .post("Cnpj/checkCnpj", {
  //         cnpj: this.cnpj_value,
  //         id_empresa: this.id_empresa,
  //         captcha: this.captcha_value,
  //         connId: this.idConn
  //       })
  //       .then(response => {
  //         this.blLoadingButton = false;

  //         if (response.dados.cnpj) {
  //           if (response.dados.situacao_cadastral == "BAIXADA") {
  //             this.blErro = true;
  //             this.strErro = "Verificar situação cadastral da empresa.";
  //           } else {
  //             this.$parent.blAtualizarReceita = false;
  //             this.$parent.setCnaeCnpj(response.dados);
  //             this.closeModal();
  //           }
  //         } else {
  //           this.blErro = true;

  //           if (response.mensagem instanceof Object) {
  //             Object.keys(response.mensagem).map(key => {
  //               this.strErro += response.mensagem[key][0] + "<br>";
  //             });
  //           } else {
  //             this.strErro = response.mensagem;

  //             if (response.mensagem == "Imagem digitada incorretamente") this.verificaCNPJ(true);
  //           }
  //         }
  //       });

  //     return false;
  //   },
  //   closeModal: function() {
  //     if (this.blLoadingButton) {
  //       return;
  //     }
  //     this.$refs.verificacaoCnae.hide();
  //   }
  // }
};
